// The top of the detail panel: a bar in the movement's status colour, the date and the amount,
// the concept and the bank's reference, then a row for each other field the bank sent
class BankMovementHeaderCell extends UITableViewCell
{
    private statusBar:MUIView = null;
    private dateLabel:MUILabel = null;
    private amountLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private referenceLabel:MUILabel = null;
    private extraView:MUIView = null;
    private extraRows:MUIView[] = [];

    private static extraKeys = ["exchangeAmount", "exchangeCurrency", "exchangeRate", "fee", "type", "typeDescription", "bankBranch", "beneficiaryAccountNumber", "beneficiaryIBAN", "beneficiaryName", "dataCode", "documentNumber", "dueDate", "reference", "reference1", "reference2"];

    awakeFromHTML(){
        this.statusBar = MUIOutlet(this, "status-bar", "MUIView");
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.referenceLabel = MUIOutlet(this, "ref-lbl", "MUILabel");
        this.extraView = MUIOutlet(this, "extra-view", "MUIView");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    setEntry(entry:BankEntry){
        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;

        let status = entry instanceof BankMovement ? BankMovementState.statusOf(entry as BankMovement) : BankMovementStatus.Complete;
        let statuses = [BankMovementStatus.Uncategorized, BankMovementStatus.MissingDocuments];
        for (let index = 0; index < statuses.length; index++){
            if (statuses[index] == status) MUICoreLayerAddStyle(this.statusBar.layer, statuses[index]);
            else MUICoreLayerRemoveStyle(this.statusBar.layer, statuses[index]);
        }

        this.dateLabel.text = entry.date != null ? ad.longDateFormatter.stringFromDate(entry.date) : null;
        this.amountLabel.text = BankMovementState.signedAmountString(entry.amount);
        if (entry.amount > 0) MUICoreLayerAddStyle(this.amountLabel.layer, "positive");
        else MUICoreLayerRemoveStyle(this.amountLabel.layer, "positive");

        this.conceptLabel.text = entry.concept;

        let reference = BankEntryCell.referenceOf(entry);
        this.referenceLabel.text = reference != null ? MIOLocalizeString("REF", "Ref.") + " " + reference : null;
        this.referenceLabel.hidden = reference == null;

        this.setExtraFields(entry, reference);
    }

    // The fields with a value, by name; the reference already shown above is left out
    private setExtraFields(entry:BankEntry, shownReference:string){
        for (let row of this.extraRows) row.removeFromSuperview();
        this.extraRows = [];

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        let keys = BankMovementHeaderCell.extraKeys.slice().sort();
        for (let key of keys) {
            let value = entry[key];
            if (value == null || value === 0 || (typeof value == "string" && value.length == 0)) continue;
            if (value === shownReference) continue;

            let row = new MUIView();
            row.init();
            row.layer.style.position = "relative";
            MUICoreLayerAddStyle(row.layer, "info-extra-row");

            let texts = [key, value instanceof Date ? ad.dateFormatter.stringFromDate(value) : String(value)];
            for (let text of texts) {
                let label = new MUILabel();
                label.init();
                label.layer.style.position = "relative";
                MUICoreLayerAddStyle(label.layer, "label");
                label.text = text;
                row.addSubview(label);
            }

            this.extraView.addSubview(row);
            this.extraRows.push(row);
        }
    }
}
